import { RoleCode } from "../utils/RolesPermissions";

export const RoutePostUsers = "/users";

export interface PayloadPostUsers {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  roleCode: RoleCode;
}

export interface ResponsePostUsers {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  userType: "MERCHANT_USER";
  merchantId: number;
  roleCode: RoleCode;
  createdBy: null;
  createdAt: string;
  updatedAt: string;
}
